module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cardCover"
  }, [_c('amp-img', {
    attrs: {
      "src": _vm.cardImgSrc,
      "alt": _vm.ndoeTitle,
      "height": "1118",
      "width": "750",
      "layout": "responsive"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-03f92b74","hasScoped":false,"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/article/amp/AmpCardCover.vue
// module id = 1725
// module chunks = 44